import api from "./api";

export async function getAllInvoiceDetails(customerId, numbers) {
  const response = await api.get(`api/customers/${customerId}/invoices`, {
    params: { numbers },
    paramsSerializer: { indexes: null },
  });
  return response.data;
}

export async function getInvoiceDetailsByAccountCode(accountCode, numbers) {
  const response = await api.get(`api/invoice-details`, {
    params: { accountCode, numbers },
    paramsSerializer: { indexes: null },
  });
  return response.data;
}

